export default {
  data: () => ({})
};
